import React from 'react';

// Helper component for individual insurance options
function InsuranceOption({ link, iconClass, label, extraInfo, onContextMenu, onClick }) {
  return (
    <li>
      <a href={link} rel="nofollow" onContextMenu={onContextMenu} onClick={onClick}>
        <i className={iconClass}></i>
        {label}
        {extraInfo && <span className="green">{extraInfo}</span>}
      </a>
    </li>
  );
}

// Helper component for each tab content
function TabContent({ id, label, products }) {
  return (
    <div className="tab">
      <input type="radio" name="tabs" checked={id === 1} id={`tab${id}`} />
      <label htmlFor={`tab${id}`}>{label}</label>
      <div id={`tab-content${id}`} className="content">
        <div className="icon-block-row">
          <div className="left-block">
            <p className="heading">{label}</p>
            <ul>
              {products.map((product, index) => (
                <InsuranceOption
                  key={index}
                  link={product.link}
                  iconClass={product.iconClass}
                  label={product.label}
                  extraInfo={product.extraInfo}
                  onContextMenu={product.onContextMenu}
                  onClick={product.onClick}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

// Main Container component
function Container() {
  const handleRightClick = (event, label) => {
    // Custom right-click handling logic
    console.log(`Right-clicked on: ${label}`);
  };

  const handleClick = (event, label) => {
    // Custom click handling logic
    console.log(`Clicked on: ${label}`);
  };

  const personalInsuranceProducts = [
    {
      link: 'https://termlife.policybazaar.com/newform?utm_content=home_v10',
      iconClass: 'icon-bg homeIconsBg term-insurance',
      label: 'Term Life',
      extraInfo: 'Covid-19 Covered',
      onContextMenu: (e) => handleRightClick(e, 'Term Life'),
      onClick: (e) => handleClick(e, 'Term Life'),
    },
    {
      link: 'https://termlife.policybazaar.com/prequotes?offerid=151&utm_term=trop_plan&utm_content=home_v10',
      iconClass: 'icon-bg homeIconsBg return-of-premium',
      label: 'Return of Premium',
      onContextMenu: (e) => handleRightClick(e, 'Return of Premium'),
      onClick: (e) => handleClick(e, 'Return of Premium'),
    },
    {
      link: 'https://termprequotes.policybazaar.com/sjb?isSJB=true&utm_content=home_v10',
      iconClass: 'icon-bg-new homeIconsBg sjb',
      label: 'Saral Jeevan Bima',
      onContextMenu: (e) => handleRightClick(e, 'Saral Jeevan Bima'),
      onClick: (e) => handleClick(e, 'Saral Jeevan Bima'),
    },
    // Add more products as needed
  ];

  return (
    <div>
      {/* More Products stats */}
      <div className="more-prd-base"></div>

      <div className="renew-prd-blk">
        <p className="heading">Renew a Policy</p>
        <div className="close close-more-prd"></div>
        <div className="close-small-renew"></div>
        <ul>
          <InsuranceOption
            link="https://liferenewal.policybazaar.com/"
            iconClass="icon-bg life-insurance"
            label="Life Insurance"
            onContextMenu={(e) => handleRightClick(e, 'Life Insurance')}
            onClick={(e) => handleClick(e, 'Life Insurance')}
          />
          <InsuranceOption
            link="https://healthrenewal.policybazaar.com/"
            iconClass="icon-bg health-insurance"
            label="Health Insurance"
            onContextMenu={(e) => handleRightClick(e, 'Health Insurance')}
            onClick={(e) => handleClick(e, 'Health Insurance')}
          />
          <InsuranceOption
            link="https://ci.policybazaar.com/?pb_campaign=hm_renewal"
            iconClass="icon-bg motor-insurance"
            label="Motor Insurance"
            onContextMenu={(e) => handleRightClick(e, 'Motor Insurance')}
            onClick={(e) => handleClick(e, 'Motor Insurance')}
          />
          <InsuranceOption
            link="https://twowheeler.policybazaar.com/?pb_campaign=hm_renewal"
            iconClass="icon-bg two-wheeler-insurance"
            label="Two Wheeler Insurance"
            onContextMenu={(e) => handleRightClick(e, 'Two Wheeler Insurance')}
            onClick={(e) => handleClick(e, 'Two Wheeler Insurance')}
          />
          <InsuranceOption
            link="https://home.policybazaar.com/renewal/?utm_content=CJ_Renewal_Pb"
            iconClass="icon-bg homeins-insurance"
            label="Home Insurance"
            onContextMenu={(e) => handleRightClick(e, 'Home Insurance')}
            onClick={(e) => handleClick(e, 'Home Insurance')}
          />
        </ul>
      </div>

      <div className="more-prd-blk casedomestic" id="homeIcons">
        <p className="heading">More Products</p>
        <div className="close close-more-prd"></div>
        <div className="close-small"></div>
        <ul className="tabs homeIcons">
          <TabContent
            id={1}
            label="Personal Insurance"
            products={personalInsuranceProducts}
          />
        </ul>
      </div>
    </div>
  );
}

export default Container;
